import { Injectable } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { CustomerUser } from 'src/app/core/interfaces/customer-user';
import { environment } from 'src/environments/environment';
import { EndPoints } from 'src/app/shared/EndPoints';
import { HttpService } from 'src/app/core/services/http/http.service';

import { CustomManageUser } from '../../../core/interfaces/customManageUser';
import { LinkedAccountResult } from '../../../core/interfaces/linked-account-result';
import { Permission } from '../../../core/interfaces/user-permission';

@Injectable({
  providedIn: 'root'
})
export class CreateCustomerUserService {

  private CPPortalBaseUrl: string;

  constructor(private httpService: HttpService) {
    this.CPPortalBaseUrl = environment.customerPortalServiceUrl;
  }

  public addCustomerUser(user: CustomerUser) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.POST_CUSTOMER_MANAGE_USER, user);
  }

  public updateCustomerUser(user: CustomerUser): Observable<{ isSuccess: boolean, message: string }> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.updateCustomerUser, user);
  }

  public getLinkedAccounts(userId: string): Observable<LinkedAccountResult[]> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.GET_LINKED_ACCOUNTS_BY_ID);
  }

  public getUserDetailsById(userId: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.loggedInUserInfo + userId);
  }

  public getUserDetailswithPermission(userId: string): Observable<CustomManageUser> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.userDetailsWithPermission + userId);
  }

  public getCurrentUserPermissionsToCreateCustomerUser(userCreationType: string): Observable<Permission[]> {
    return this.httpService.Get(this.CPPortalBaseUrl +
    EndPoints.loggedUserPermissions + userCreationType);
  }

  public formatPhone(phone: AbstractControl) {
    const phoneControl = phone;
    let value: string = phoneControl.value;
    value = value ? value.replace(/[^0-9]*/g, '') : '';
    if (value.length === 10) {
      phoneControl.setValue(value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6));
      phoneControl.setValidators([Validators.maxLength(12)]);
    } else {
      phoneControl.setValue(value);
      phoneControl.setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10)]);
    }
    phoneControl.updateValueAndValidity();
  }
      
  public checkAnyUserExistsOnPortalByEmail(email: string, existingEmail?: string) {
    const apiUrl = this.CPPortalBaseUrl + EndPoints.CheckAnyUserExistsOnPortalByEmail;
    const data = {
      Email: email,
      ExistingEmail: existingEmail ?? null
    }
    return this.httpService.Post(apiUrl, data);
  }
}